import React from "react";
function getUpdate(data,  updatedTime) {
  if (data[updatedTime]) {
      let date = data[updatedTime].toString().toUpperCase();
      return date.split(' ').slice(0, 3).join(' ');
  }

    return 'Fishing Koi';
}
class Member extends React.Component {
    constructor(props) {
      super(props);

    }

    render() {
      let ap = this.props.info.ap;
      let dp = this.props.info.dp;
      let aap = this.props.info.awk_ap;
      return (
        <tbody><tr>
          <td>{this.props.info.family_name}</td>
          <td>{this.props.info.character_name}</td>
          <td>{ap}</td>
          <td>{aap}</td>
          <td>{dp}</td>
          <td>{(((ap>aap)?ap:aap)+dp)/2}</td>
          <td>{this.props.info.level}</td>
          <td>{this.props.info.class_name}</td>
          <td>{getUpdate(this.props.info,'updated_at')}</td>
        </tr></tbody>
      );
    }
  }
  
  export default Member;